@if (isOpen) {
  <div
    class="fixed inset-0 z-[70] flex items-end justify-center bg-black/60 p-3 md:items-center"
    (click)="closeModal()">
    <div class="w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl" (click)="$event.stopPropagation()">
      <div class="flex items-start justify-between border-b border-gray-200 p-4">
        @if (alreadyReserved) {
          <h4 class="text-lg font-semibold">
            {{ 'event.cancel-title' | translate }}
          </h4>
        } @else {
          <h4 class="text-lg font-semibold">
            {{ 'event.confirm-title' | translate }}
          </h4>
        }
        <button
          type="button"
          class="rounded-lg p-1.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900"
          aria-label="Close"
          (click)="closeModal()">
          <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path clip-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              fill-rule="evenodd">
            </path>
          </svg>
        </button>
      </div>
      <div class="max-h-[75vh] overflow-y-auto p-4">
        @if (!isLoading) {
          <div>
            @if (alreadyReserved) {
              <div>
                <p>
                  {{ 'event.cancel-message' | translate }} <strong>{{xploreItem.name}}</strong>?
                </p>
              </div>
            } @else {
              <form [formGroup]="reservationFormGroup">
                <div class="mb-6 grid gap-6 md:grid-cols-2">
                  <div>
                    <label for="first_name" class="mb-2 block text-sm font-medium">{{ 'event.reservation.name' | translate}}</label>
                    <input formControlName="name"
                      type="text" id="first_name" class="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
                      placeholder="{{ 'event.reservation.name_placeholder' | translate}}" required>
                    @if (shouldShowError('name')) {
                      <div class="text-xs italic text-red-500">
                        {{ 'event.reservation.name_error' | translate}}
                      </div>
                    }
                  </div>
                  <div>
                    <label for="last_name" class="mb-2 block text-sm font-medium">{{ 'event.reservation.surname' | translate}}</label>
                    <input formControlName="surname"
                      type="text" id="last_name" class="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
                      placeholder="{{ 'event.reservation.surname_placeholder' | translate}}" required>
                    @if (shouldShowError('surname')) {
                      <div class="text-xs italic text-red-500">
                        {{ 'event.reservation.surname_error' | translate}}
                      </div>
                    }
                  </div>
                  <div>
                    <label for="phone" class="mb-2 block text-sm font-medium text-gray-900">
                      {{ 'event.reservation.phone' | translate}}
                    </label>
                    <input formControlName="phoneNumber"
                      type="tel" id="phone" class="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
                      placeholder="{{ 'event.reservation.phone_placeholder' | translate}}">
                    @if (shouldShowError('phoneNumber')) {
                      <div class="text-xs italic text-red-500">
                        {{ 'event.reservation.phone_error' | translate}}
                      </div>
                    }
                  </div>
                  <div>
                    <label for="additionalNumberOfPeople" class="mb-2 block text-sm font-medium text-gray-900">
                      {{ 'event.reservation.additional_number_of_people' | translate}}
                    </label>
                    <select [ngClass]="{'disabled pe-none': actualEvent.multipleReservationsAllowed === false}"
                      [disabled]="actualEvent.multipleReservationsAllowed === false"
                      formControlName="additionalNumberOfPeople"
                      id="additionalNumberOfPeople"
                      class="block w-full rounded-lg border border-gray-300 p-2.5 text-sm">
                      <option [selected]="actualEvent.multipleReservationsAllowed === false" value=0>
                        {{ 'event.reservation.multiple_reservations_not_allowed' | translate}}
                      </option>
                      <option [selected]="actualEvent.multipleReservationsAllowed === true" value=0>
                        {{ 'event.reservation.additional_number_of_people_zero' | translate}}
                      </option>
                      <option value=1>1 {{ 'event.reservation.additional_number_of_people_single' | translate}}</option>
                      <option value=2>2 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=3>3 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=4>4 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=5>5 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=6>6 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=7>7 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=8>8 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                      <option value=9>9 {{ 'event.reservation.additional_number_of_people_multiple' | translate}}</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label for="additionalInfo" class="mb-2 block text-sm font-medium text-gray-900">
                    {{ 'event.reservation.additional_info' | translate}}
                  </label>
                  <textarea formControlName="additionalInfo"
                    id="additionalInfo" class="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
                    maxlength="300"
                    placeholder="{{ 'event.reservation.additional_info_placeholder' | translate}}"
                    style="max-height: 200px">
                  </textarea>
                </div>
              </form>
            }
            <div class="mt-5 flex justify-end gap-2 border-0">
              <button type="button"
                class="rounded-full border border-gray-300 px-4 py-2 text-sm font-medium"
                (click)="closeModal()">
                {{ 'event.reservation.abort' | translate}}
              </button>
              @if (!alreadyReserved) {
                <button [disabled]="reservationFormGroup.invalid"
                  type="button"
                  class="custom-color rounded-full px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50"
                  (click)="submitReservation(reservationFormGroup)">
                  {{ 'event.reservation.confirm' | translate}}
                </button>
              }
              @if (alreadyReserved) {
                <button
                  type="button"
                  class="custom-color rounded-full px-4 py-2 text-sm font-semibold text-white"
                  (click)="deleteReservation()">
                  {{ 'event.reservation.cancel' | translate}}
                </button>
              }
            </div>
          </div>
        }
        @if (isLoading) {
          <div class="flex w-full justify-center py-8">
            <div class="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-theme-primary"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
